// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MpWh","toggle":"styles_toggle__1cPV8","preview":"styles_preview__8gjee"};